document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('scroll', function () {
    // 通用缓入效果
    $(".js-scroll-fade-in, .js-scroll-fade-in-bottom, .js-scroll-fade-in-top, .js-scroll-fade-in-left, .js-scroll-fade-in-right").each(function(){
      let that=this;
      if (($(window).scrollTop() + $(window).height()) > $(that).offset().top) {
          $(that).addClass('is_over');
      }
      else {
          $(that).removeClass('is_over');
      }
    })
  });
});